export const api_host = process.env.VUE_APP_API_URL;
export const api_prefix = "/api/v1";
export const API_URL_BASE = `${api_host}${api_prefix}`;

export const KEYCLOAK_REALM = process.env.VUE_APP_KEYCLOACK_REALM;
export const KEYCLOAK_CLIENT_ID = process.env.VUE_APP_KEYCLOACK_CLIENT_ID;
export const KEYCLOAK_URL = process.env.VUE_APP_KEYCLOACK_URL;
export const API_URL_SCANNER = process.env.VUE_APP_API_URL_SCANNER;

export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
